<template>
	<div class="basic_wrap" style="position: relative;padding-bottom: 50px;">
		<div class="red_top_bg">
			<!-- <div class="back_left" @click="$router.back()"></div> -->
			<van-icon  class="back_left" color="#ffffff" size="20"  @click="$router.back()" name="arrow-left" />
			<div class="record" @click="$router.push('/withdraw/record')">
				<!-- <img src="../img/user/record_b.png"> -->
				<van-icon  color="#ffffff" size="20" name="clock-o" />
			</div>
		</div>

		<!-- type==1 时候的切换方式 -->
		<div class="changeBlanceBox" v-show="showUsdtToOther">

			<div class="desc_warp">
				<img src="../img/user/usdt.png" />
				<div class="flex_center userBalance">
					<p>{{ $t('可提现余额') }}</p>
				</div>
				<p>{{ common.currency_symbol_basic() }}{{ userBalance }}
				</p>
			</div>
			<!-- <div class="icons"><img @click="ChangeType(1)" class="change_img" src="../img/user/change.png" /></div>
			<div class="desc_warp">
				<img src="../img/user/trx.png" @click="ChangeType(2)" />
				<div class="flex_center userBalance">
					<p>{{ $t('可提现余额') }}TRX</p>
				</div>
				<p>{{ userOtherBalance }}</p>
			</div> -->
		</div>

		<!-- type==2 时候的切换方式 -->
		<div class="changeBlanceBox" v-show="showTrxToOther">
			<div class="desc_warp">
				<img src="../img/user/trx.png" @click="ChangeType(1)" />
				<div class="flex_center userBalance">
					<p>{{ $t('可提现余额') }}</p>
				</div>
				<p>{{ userBalance }}TRX</p>
			</div>

			<div class="icons"><img @click="ChangeType(2)" class="change_img" src="../img/user/change.png" /></div>
			<div class="desc_warp">
				<img src="../img/user/usdt.png" @click="ChangeType(2)" />
				<div class="flex_center userBalance">
					<p>{{ $t('可提现余额') }}</p>
				</div>
				<p>{{ common.currency_symbol_basic() }}{{ userOtherBalance }}
				</p>
			</div>
		</div>


		<div class="withdraw_wrap">
			<div class="block_div item choose_wallet">
				<div class="flex_center">
					<p>{{ $t('withdraw.account') }}</p>
					<!-- <div @click="show = true"> -->
					<div>
						<span>{{ withdraw_name }}</span>
						<van-icon name="arrow" color="#999" />
					</div>
				</div>
			</div>
			<van-action-sheet v-model="show" cancel-text=""
				:description="$t('withdraw.accountPlaceholder')" close-on-click-action @select="onSelect" >
				<div class="bank_info" v-if="wallets.length > 0">
					{{ wallets[0].name }} <div style="flex: 1;"></div> <span @click="$router.push('/wallet/bank/'+wallets[0].value)" class="bank_info_lab"></span> 
				</div>
				</van-action-sheet>
			<div class="block_div item">
				<div class="">
					<p class="withdraw_money_tips">{{ $t('withdraw.amount') }}</p>
					<div class="flex_center">
						<van-field v-model="wallet.money" type="number" :placeholder="$t('withdraw.amountPlaceholder') + withdraw_min +' USDT'" />
					</div>
				</div>
			</div>

			<!-- <div class="block_div item">
				<div class="">
					<p class="withdraw_money_tips">{{ $t('user.txt11') }}</p>
					<div class="flex_center">
						<van-field v-model="wallet.paypwd" type="password" :placeholder="$t('user.txt12')" />
					</div>
				</div>
			</div> -->
		</div>
		<!-- <p class="withdraw_time_tips">
			{{ $t('withdraw.frozenAmount') }}{{ type == 1 ? common.currency_symbol_basic() : "" }}{{
				common.precision_basic(frozenAmount) }}{{ type == 2 ? "TRX" : "" }}<br>
			{{ $t('withdraw.needInvest') }}<br>
			{{ $t('withdraw.withdrawNum') }}{{ withdraw_num }}{{ $t('utils.times' + times) }}<br>
			{{ $t('withdraw.withdrawAmount') }}{{ type == 1 ? common.currency_symbol_basic() : "" }}{{
				common.precision_basic(withdraw_min) }}{{ type == 2 ? "TRX" : "" }}<br>
			{{ $t('withdraw.withdrawTips') }}
		</p> -->
		<div class="func_box">
			<!-- <div class="basic_btn btn" @click="submit()">
			
		</div> -->
			<div class="func_btn" @click="submit()">{{ $t('withdraw.withdrawNow') }}</div>
		</div>


		<!-- 绑定提款密码 -->
		<van-popup class="loginModel" v-model="showBindPayPass" closeable round :style="{ width: '90%' }">

			<div class="phoneLogin">
				<div class="title">{{ $t('login.txt11') }}</div>
				<!-- <div class="phoneInputBox"> <input type="text" class="phoneInput" v-model="params1.oldpassword"
:placeholder="$t('user.txt6')" />
</div> -->
				<div class="phoneInputBox"> <input type="text" class="phoneInput" v-model="params1.password"
						:placeholder="$t('user.txt11')" />
				</div>

				<!-- 绑定按钮 -->
				<div class="bindBtnBox">

					<van-button class="bindBtn" type="primary" @click="updataPass(1)" block>{{
						$t('user.save')
					}}</van-button>
				</div>
			</div>
		</van-popup>
	</div>
</template>

<script>
import Vue from 'vue';
import bsHeader from '../../components/bsHeader.vue'
import Fetch from '../../utils/fetch'
import {
	Icon,
	ActionSheet,
	Field,
	Dialog
} from 'vant';
Vue.use(Icon).use(ActionSheet).use(Field);
export default {
	name: "",
	components: {
		bsHeader
	},
	data() {
		return {
			rate: localStorage.getItem('rate'),
			data: [],
			userBalance: "0",
			userOtherBalance: "0",
			frozenAmount: '0',
			fundBalanceTrx: 0.00,
			fundBalanceUsd: 0.00,
			showUsdtToOther: false,
			showTrxToOther: false,
			showBindPayPass: false,
			withdraw_name: this.$t('withdraw.bindAccount'),
			show: false,
			wallets: [],
			wallet: {
				money: '',
				id: 0,
				paypwd: ''

			},
			withdraw_num: 0,
			withdraw_min: 0,
			times: 0,
			type: 1,
			paypwd: "",
			params1: {
				// oldpassword: '',
				password: '',
			},
			charge: 0
		};
	},
	created() {
		if (window.plus) {
			plus.navigator.setStatusBarBackground('#FFFFFF');
			plus.navigator.setStatusBarStyle('dark');
		}
		if (this.$route.query.type && this.$route.query.type == "trx") {
			this.type = 2;
		}
		this.$parent.footer('user', false);
		this.showOrHide();
	},
	mounted() {
		this.start();
	},
	methods: {
		start() {
			var isapp = 0;
			if (window.plus) {
				isapp = 1;
			}
			Fetch('/user/getUserInfo').then(r => {

				//判断paypwd是否为空
				this.paypwd = r.data.paypwd;
				// if (this.paypwd == null || this.paypwd == '') {
				// 	this.showBindPayPass = true;

				// }
			})
			Fetch('/user/info', {
				isapp: isapp
			}).then((r) => {
				this.fundBalanceTrx = r.data.fundBalanceTrx;
				this.fundBalanceUsd = r.data.fundBalanceUsd;
			});
			Fetch('/user/getWallets', {
				type: this.type
			}).then(r => {
				console.log(r.data.userBalance)
				// this.userBalance = r.data.userBalance;
				this.userBalance = r.data.walletsother.userBalance;
				this.frozenAmount = r.data.frozenAmount;
				this.withdraw_min = r.data.withdrawMin;
				this.withdraw_num = r.data.withdrawNum;
				this.charge = r.data.charge;

				this.times = r.data.withdrawNum;
				if (this.times > 1) this.times = 2;
				var walletList = [];
				r.data.wallets.forEach(item => {
					walletList.push({
						name: item.wname + "(" + item.account + ")",
						value: item.id,
						type: item.type,
					})
				})

				if (walletList.length == 0) {
					walletList.push({
						name: this.$t('withdraw.bindAccount'),
						value: 0,
						color: "#FF0000",
					})
				}
				this.withdraw_name = walletList[0].name;
				this.wallet.id = walletList[0].value;
				this.wallets = walletList;
			})
		},
		updataPass(index) {
			if (this.params1.password == "") {
				this.$toast(this.$t('user.txt10'));
				return;
			}
			Fetch('/user/editpayPassword', {
				...this.params1,
			}).then(r => {
				this.showBindPayPass = false;
				this.params1.password = '';
				this.$router.replace('/user');
			})

		},
		//    切换交易方式
		ChangeType(index) {
			if (index == 1) {
				this.type = 2;
			} else {
				this.type = 1;
			}
			this.showOrHide();
			this.start();


		},

		// 初始化时候根据type 判断显示隐藏 切换类型
		showOrHide() {
			if (this.type == 1) {
				this.showUsdtToOther = true;
				this.showTrxToOther = false;
			} else {
				this.showUsdtToOther = false;
				this.showTrxToOther = true;
			}
		},

		onSelect(item) {
			if (item.value == 0) {
				this.$router.push('/wallet')
			}
			this.withdraw_name = item.name;
			this.wallet.id = item.value;
		},
		changeAmount() { },
		submit() {
			if (this.wallet.id == 0) {
				this.$toast(this.$t('withdraw.accountEmpty'));
				return false;
			}
			if (this.wallet.money < this.withdraw_min) {
				this.$toast(this.$t('withdraw.amountPlaceholder') + this.withdraw_min +' USDT');
				return false;
			}
			if (this.wallet.money - this.userBalance > 0) {
				console.log('111111111111', this.wallet.money, this.userBalance);
				this.$toast(this.$t('withdraw.amountError'));
				return false;
			}
			if (this.wallet.money - this.withdraw_min < 0) {
				this.$toast(this.$t('withdraw.withdrawAmount') + (this.type == 1 ? this.common.currency_symbol_basic() : "") + this.common.precision_basic(this.withdraw_min) + (this.type == 2 ? "TRX" : ""));
				return false;
			}
			// if (this.wallet.paypwd == "") {
			// 	this.$toast(this.$t('user.txt13'));
			// 	return false;
			// }
			Fetch('/user/withdraw', {
				...this.wallet,
				type: 4
			}).then(r => {
				if (this.charge > 0) {
					if(this.showTrxToOther){
						//提现trx
						Dialog.alert({
						message:
							this.$t('当前提现金额') + ":" + this.wallet.money
							//  +'TRX'+
							// "<br/>" +
							// "<br/>" +
							// this.$t('需要扣除手续费') + ":" + this.charge + "%"
							,
						confirmButtonText: window.vm.$i18n.t('utils.confirm')
					}).then(() => {
						// 处理确认按钮点击事件
						this.$router.replace('/withdraw/record');
						// 可以在这里执行你想要的操作
					});
					}else{
						Dialog.alert({
						message:
							this.$t('当前提现金额') + ":" + this.wallet.money +this.common.currency_symbol_basic()
							//  +
							// "<br/>" +
							// "<br/>" +
							// this.$t('需要扣除手续费') + ":" + this.charge + "%"
							,
						confirmButtonText: window.vm.$i18n.t('utils.confirm')
					}).then(() => {
						// 处理确认按钮点击事件
						this.$router.replace('/withdraw/record');
						// 可以在这里执行你想要的操作
					});
					}
					
				} else {
					this.$router.replace('/withdraw/record');
				}


			})
		},
		showMsg() {
			this.$dialog.alert({
				closeOnClickOverlay: true,
				showConfirmButton: false,
				message: "<p style='text-align: left'>" +
					this.$t('withdraw.frozenAmount') +
					this.common.currency_symbol_basic() +
					this.common.precision_basic(this.frozenAmount) +
					" " +
					"<br>" +
					this.$t('withdraw.needInvest') +
					"</p>",
			}).catch(() => {
				// on close
			});
		}
	}
};
</script>

<style lang="less" scoped>
.func_box {
	display: flex;
	align-items: center;
	justify-content: center;
	max-width: 750px;
	position: fixed;
	bottom: 10px;
	width: 100%;

	.func_btn {
		width: 80%;
		background-color: #326CF6;
		height: 50px;
		display: flex;
		align-items: center;
		justify-content: center;
		height: 50px;
		font-size: 16px;
		width: 80%;
		background-size: 100% 100%;
		border-radius: 23px;
		color: #FFFFFF;
		background: #0F6EFF;
		text-align: center;
	}

}

.loginModel {
	background: white;
	box-sizing: border-box;
	text-align: center;
	color: #ffffff;
	-webkit-border-radius: 10px;
	-moz-border-radius: 10px;
	border-radius: 10px;
	padding: 0 28px;
	padding-top: 42px;
	padding-bottom: 28px;
}

.phoneLogin {
	.title {
		color: #0A0A27;
		font-weight: bold;
		font-size: 18px;
		text-align: center;
	}

	.phoneInputBox {
		.phoneInput {
			width: 100%;
			border-radius: 4px;
			background: none;
			background: #F5F6F8;
			height: 60px;
			border: 0px;
			line-height: 60px;
			padding-left: 16px;
			outline: none;
			margin-top: 20px;
			font-size: 14px;
			color: #0A0A27;
		}

		input::placeholder {
			font-weight: bold;
			opacity: 0.5;
			color: #333;
		}
	}


	.codeBox {
		display: flex;
		justify-content: space-between;
		margin-top: 20px;

		.codeInput {
			border-radius: 4px;
			background: none;
			background: #F5F6F8;
			height: 60px;
			border: 0px;
			line-height: 60px;
			padding-left: 16px;
			outline: none;
			font-size: 14px;
			color: #0A0A27;
			width: 100%;

			::-webkit-input-placeholder {
				color: #333333;
				font-size: 12px;
			}
		}

		.pic1 {
			margin-left: 8px;
			width: 130px;
		}

	}

	.bindBtnBox {

		.bindBtn {
			height: 38px;
			border-radius: 100px;
			margin-top: 44px;
			border-radius: 4px;
			background: #326CF6;

			.van-button__text {
				font-size: 14px;
				font-weight: 400;
				color: white;
			}
		}
	}

	.input_box_email {
		margin-top: 20px;

		.input_send_box {
			display: flex;
			justify-content: space-between;
			align-items: center;
			width: 100%;
			height: 60px;
			background: #F5F6F8;
			margin-top: 15px;
			border-radius: 8px;


			.input_main {
				width: 100%;
				border-radius: 4px;
				background: none;
				height: 60px;
				border: 0px;
				line-height: 60px;
				padding-left: 16px;
				outline: none;
				font-size: 14px;
				color: #0A0A27;
			}

			input::placeholder {
				font-weight: bold;
				opacity: 0.5;
				color: #333;
			}


			.input_send {
				height: 100%;
				width: 150px;
				display: flex;
				justify-content: center;
				align-items: center;
				background-color: #326CF6;
				border-radius: 0 8px 8px 0;
				color: white;
				font-size: 12px;
			}


		}

	}



}

.red_top_bg {
	position: fixed;
	top: 0;
	z-index: 10;
	// background-color: #FFFFFF;

	.record {
		position: absolute;
		top: 11px;
		right: 15px;

		img {
			width: 22px;
			height: 22px;
		}
	}
}

.changeBlanceBox {
	display: flex;
	justify-content: space-around;
	align-items: center;
	padding-top: 60px;
	padding-bottom: 20px;

	.change_img {
		width: 60px;
		height: 60px;
	}
}

.desc_warp {
	text-align: center;
color: #ffffff;
	.userBalance {
		justify-content: center;
	}

	img {
		width: 100px;
		height: 100px;
	}

	p:nth-child(2) {
		font-size: 14px;
		color: #999;
	}

	p:nth-child(3) {
		font-size: 20px;
		font-weight: bold;
		margin: 10px 0;
	}
}

.withdraw_wrap {
	.item {
		margin-bottom: 10px;
		padding: 20px;

		.flex_center {
			justify-content: space-between;
		}

		.withdraw_money_tips {
			margin-bottom: 10px;
		}

		.money_mark {
			font-size: 18px;
			font-weight: bold;
			margin-left: 6px;
		}

		div:nth-child(1) {
			font-size: 14px;
			// font-weight: bold;
			color: #999;
		}

		// div:nth-child(2) {
		// 	text-align: right;
		// 	font-size: 14px;
		// 	font-weight: bold;
		// 	color: #999;
		// }
	}

}

.withdraw_time_tips {
	padding: 10px 16px 14px 16px;
	line-height: 2;
	font-size: 12px;
	color: #f12211;
}

.btn {
	width: 80%;
	margin: 50px 0 0 10%;
	position: fixed;
	left: 0;
	bottom: 0;
}

/deep/ .van-cell {
	padding: 10px 16px 10px 10px;
}

/deep/ .van-action-sheet__item {
	text-align: left;
}

/deep/ .van-action-sheet__item {
	padding: 10px 16px;
	font-size: 14px;
}

/deep/ .van-dialog__message {
	text-align: left;
}

/deep/.van-action-sheet {
	padding-bottom: 10px;
}
.bank_info{
	display: flex;
	padding: 15px ;
}
.bank_info_lab{
	color: #f12211;
}
</style>
